"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const constants_1 = require("../constants");
function OnTop({ refElement, children }) {
    const [{ top, left, right }, setPosition] = react_1.useState({
        top: 0,
        left: 0,
        right: 0
    });
    react_1.useEffect(() => {
        const bodyOverflow = document.body.style.overflow;
        if (refElement) {
            const pos = refElement.getBoundingClientRect();
            setPosition({
                top: pos.top < constants_1.VIEWPORT_MARGIN ? constants_1.VIEWPORT_MARGIN : pos.top + pos.height,
                left: pos.left < constants_1.VIEWPORT_MARGIN ? constants_1.VIEWPORT_MARGIN : pos.left,
                right: window.innerWidth - pos.left - pos.width
            });
            document.body.style.overflow = 'hidden';
        }
        return () => {
            document.body.style.overflow = bodyOverflow;
        };
    }, [setPosition, refElement]);
    return (jsx_runtime_1.jsx("div", Object.assign({ style: { position: 'fixed', left, top, right, zIndex: 10 } }, { children: children }), void 0));
}
exports.default = react_1.memo(OnTop);
//# sourceMappingURL=onTop.js.map